import { NavLink,useNavigate } from "react-router-dom";


// import logo from '../assets/logo.png';


export default function SidebarNavigation( {setAuth,isRes,setIsRes}){
        const navigate = useNavigate();
        const reversesetIsRes=()=>{
            setIsRes(false)
            
        }
    const Logout = ({})=>{
        alert("Are You Sure ! want to logout")
        setAuth(false)
        reversesetIsRes()
        navigate("/login");
        sessionStorage.clear();
    }

    const activeStyle = {
        background: '#0000003d',
        border: '1px solid'
    }

    const meData = JSON.parse(sessionStorage.getItem('LoginData')) 

    const products = meData.products.split(',')


    // function toggleli1(){
    //     const myCollapsible = document.getElementById('collapsePayout');
    //     console.log("myCollapsible.attributes--",myCollapsible.attributes)
    
    // }

    return (
        <div className="sidebarnavi themebg-1 pt-5">
            {/* <div className="p-3 bg-white"><img src={logo} width={70} alt="Logo" /></div> */}
           
            {/* <ul className="list-group rounded-0">
                {products[0]==='PAYIN' ? 
                <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
                    <NavLink className="nav-link p-3 d-flex align-items-center" data-bs-toggle="collapse" to="#collapsePayin" >
                        <i className="fa-solid fa-circle-dollar-to-slot"></i>
                        <strong className="ms-2">PAYIN SECTION</strong>
                        <span className="ms-2">&#8595;</span>
                    </NavLink>
                    <div className="collapse ms-3" id="collapsePayin">
                    {isRes ?  <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/resellerdashboard" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                        </NavLink> :<NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/dashboard" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                        </NavLink>}
                        {isRes ?   <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/transaction" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">TRANSACTIONS</strong>
                        </NavLink> :<div><NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/manualorder" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">MANUALORDER</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/transactions" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">TRANSACTIONS</strong>
                        </NavLink></div>
                        }
                       
                       
                    </div>
                </li> : ''}
                {products[0]==='PAYOUT' || products[1]==='PAYOUT' ? 
                <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
                    <NavLink className="nav-link p-3 d-flex align-items-center" data-bs-toggle="collapse" to="#collapsePayout">
                        <i className="fa-solid fa-money-bill-transfer"></i>
                        <strong className="ms-2">PAYOUT SECTION</strong>
                        <span className="ms-2">&#8595;</span>
                    </NavLink>
                    <div className="collapse ms-3" id="collapsePayout">
                        
                        {isRes ? 

                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/payout-dashboard" style={({ isActive }) => isActive ? activeStyle : undefined}>
                        <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                        </NavLink>
                        
                        : <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/payoutdashboard" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                        </NavLink>
                        }

                        {isRes ?  <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/RPassbook" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PASSBOOK</strong>
                        </NavLink> : <div>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/wallet" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">WALLET</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/fundtransfer" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">FUND TRANSFER</strong>
                        </NavLink>
                        <NavLink className="list-group-item ps-4 p-2 border-0 text-white themebg-1" to="/passbook" style={({ isActive }) => isActive ? activeStyle : undefined}>
                            <span>&#8594;</span><strong className="ms-2">PASSBOOK</strong>
                        </NavLink> </div> }
                    </div>
                </li> : ''}
            </ul> */}

<ul className="list-group rounded-0" id="accordionMenu">
  {/* PAYIN Section */}
  {products[0] === 'PAYIN' && (
    <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
      <NavLink
        className="nav-link p-3 d-flex align-items-center"
        data-bs-toggle="collapse"
        to="#collapsePayin"
        role="button"
        aria-expanded="false"
        aria-controls="collapsePayin"
      >
        <i className="fa-solid fa-circle-dollar-to-slot"></i>
        <strong className="ms-2">PAYIN SECTION</strong>
        <span className="ms-2">&#8595;</span>
      </NavLink>
      <div
        className="collapse ms-3"
        id="collapsePayin"
        data-bs-parent="#accordionMenu"
      >
        {isRes ? (
          <NavLink
            className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
            to="/resellerdashboard"
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            <span>&#8594;</span>
            <strong className="ms-2">DASHBOARD</strong>
          </NavLink>
        ) : (
          <NavLink
            className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
            to="/dashboard"
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            <span>&#8594;</span>
            <strong className="ms-2">DASHBOARD</strong>
          </NavLink>
        )}
        {isRes ? (
          <NavLink
            className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
            to="/transaction"
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            <span>&#8594;</span>
            <strong className="ms-2">TRANSACTIONS</strong>
          </NavLink>
        ) : (
          <>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/manualorder"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">MANUALORDER</strong>
            </NavLink>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/transactions"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">TRANSACTIONS</strong>
            </NavLink>
          </>
        )}
      </div>
    </li>
  )}

  {/* PAYOUT Section */}
  {(products[0] === 'PAYOUT' || products[1] === 'PAYOUT') && (
    <li className="list-group-item p-0 rounded bg-transparent text-white border-0">
      <NavLink
        className="nav-link p-3 d-flex align-items-center"
        data-bs-toggle="collapse"
        to="#collapsePayout"
        role="button"
        aria-expanded="false"
        aria-controls="collapsePayout"
      >
        <i className="fa-solid fa-money-bill-transfer"></i>
        <strong className="ms-2">PAYOUT SECTION</strong>
        <span className="ms-2">&#8595;</span>
      </NavLink>
      <div
        className="collapse ms-3"
        id="collapsePayout"
        data-bs-parent="#accordionMenu"
      >
        {isRes ? (
          <>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/payout-dashboard"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">DASHBOARD</strong>
            </NavLink>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/RPassbook"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">PASSBOOK</strong>
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/payoutdashboard"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">DASHBOARD</strong>
            </NavLink>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/wallet"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">WALLET</strong>
            </NavLink>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/fundtransfer"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">FUND TRANSFER</strong>
            </NavLink>
            <NavLink
              className="list-group-item ps-4 p-2 border-0 text-white themebg-1"
              to="/passbook"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span>&#8594;</span>
              <strong className="ms-2">PASSBOOK</strong>
            </NavLink>
          </>
        )}
      </div>
    </li>
  )}
</ul>



            {/* <div className="accordion accordion-flush" id="accordionFlushExample">
                <div className="accordion-item">
                    <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                        <i className="fa-solid fa-circle-dollar-to-slot"></i>
                        <strong className="ms-2">PAYIN SECTION</strong>
                    </button>
                    </h2>
                    <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                        <div className="themebg-1">
                            <NavLink className="list-group-item ps-4 p-2 border-0 text-white" to="/dashboard" style={({ isActive }) => isActive ? activeStyle : undefined}>
                                <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                            </NavLink>
                            <NavLink className="list-group-item ps-4 p-2 border-0 text-white" to="/transactions" style={({ isActive }) => isActive ? activeStyle : undefined}>
                                <span>&#8594;</span><strong className="ms-2">TRANSACTIONS</strong>
                            </NavLink>
                            <NavLink className="list-group-item ps-4 p-2 border-0 text-white" to="/manualorder" style={({ isActive }) => isActive ? activeStyle : undefined}>
                                <span>&#8594;</span><strong className="ms-2">MANUALORDER</strong>
                            </NavLink>
                        </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                        <i className="fa-solid fa-money-bill-transfer"></i>
                        <strong className="ms-2">PAYOUT SECTION</strong>
                    </button>
                    </h2>
                    <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                        <div className="themebg-1">
                            <NavLink className="list-group-item ps-4 p-2 border-0 text-white" to="/dashboardd" style={({ isActive }) => isActive ? activeStyle : undefined}>
                                <span>&#8594;</span><strong className="ms-2">DASHBOARD</strong>
                            </NavLink>
                            <NavLink className="list-group-item ps-4 p-2 border-0 text-white" to="/wallet" style={({ isActive }) => isActive ? activeStyle : undefined}>
                                <span>&#8594;</span><strong className="ms-2">WALLET</strong>
                            </NavLink>
                            <NavLink className="list-group-item ps-4 p-2 border-0 text-white" to="/fundtransfer" style={({ isActive }) => isActive ? activeStyle : undefined}>
                                <span>&#8594;</span><strong className="ms-2">FUND TRANSFER</strong>
                            </NavLink>
                            <NavLink className="list-group-item ps-4 p-2 border-0 text-white" to="/passbook" style={({ isActive }) => isActive ? activeStyle : undefined}>
                                <span>&#8594;</span><strong className="ms-2">PASSBOOK</strong>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div> */}


            <li className="list-group-item p-0 rounded bg-transparent w-100 text-white border-0 logout-btn">
                <button className="nav-link p-3 d-flex align-items-center" onClick={Logout}>
                    {/* href="/login"> */}
                    <i className="fa-solid fa-power-off"></i>
                    <strong className="ms-2">LOGOUT</strong>
                </button>
            </li>
            
        </div>
    )
}